module.exports = __webpack_public_path__ + "img/login-v2.8082128c.svg";